import { gpHome } from '../../app';
import { IAuthorisationStatus } from '../../../app-common/services/authorisation-checker-with-caching-service';
import { ILoginInputs } from '../../../app-common/services/login-service';
import { IAuthService } from '../../services/auth-service';
import { AccountsService } from '../../services/accounts-service';
import { ILogglyService } from '../../../app-common/services/jsloggly-service';
import { IRouteAuthService, IRouteAuthServiceEvents } from '../../services/route-auth-service';
import { AppSettings } from '../../app-settings';
import loginTemplate from './login.html';

class LoginController {
    static $inject = ['$scope', '$location', 'authService', 'accountsService', 'gpLogglyService', 'gpRouteAuthService'];
    private readonly authEventOptions: IRouteAuthServiceEvents = {
        loggedIn: () => this.$location.path('/plans'),
        loggedOut: () => { },
    };
    passwordResetEmail: string | null = null;
    allowPasswordReset = true;
    authentication: IAuthorisationStatus;
    hideLoginScreen = AppSettings.hideLoginUntilRefresh;
    readonly loginData: ILoginInputs = {
        email: "",
        password: ""
    };

    passwordResetError = "";
    messageError = "";
    messageInfo = "";

    constructor(
        private $scope: ng.IScope,
        private $location: ng.ILocationService,
        private authService: IAuthService,
        private accountsService: AccountsService,
        private gpLogglyService: ILogglyService,
        private gpRouteAuthService: IRouteAuthService) {

        this.authService.authorisationChanged(authStatus => {
            this.authentication = authStatus;
        });

        // if we've logged in through another window, then this will trigger and we ought to redirect to plans.
        this.gpRouteAuthService.register(this.authEventOptions);
    }

    login = () => {
        this.gpLogglyService.information("Login started for {UserEmail}", [this.loginData.email], { ClientContext: 'loginController' });
        this.passwordResetError = "";
        this.messageError = "";
        this.messageError = "";
        const loginRequest = this.authService.login(this.loginData);

        loginRequest.then((response) => {
            this.gpLogglyService.information("Login success for {UserEmail}", [this.loginData.email], { ClientContext: 'loginController' });
            this.gpLogglyService.information("Navigating to plan list", [], { controller: 'loginController' });

            // We use window.location.href instead of this.$location.path because we need to 
            // redirect to the server to check for payment and status. If all is well it will redirection to /#/welcome
            window.location.href = "/welcome";
        }).catch(err => { });

        loginRequest.catch((err: ng.IHttpResponse<any>) => {
            this.gpLogglyService.information("Login failed for {UserEmail}", [this.loginData.email], { ClientContext: 'loginController' });
            this.messageError = err.data.error_description;
        });
    }

    sendPasswordReset = () => {
        const email = this.loginData.email;

        this.passwordResetError = "";
        this.messageError = "";
        this.messageInfo = "Sending reset email..."
        this.passwordResetEmail = email;

        this.accountsService.requestChangePasswordEmail(email)
            .then(() => {
                this.messageInfo = `We sent an email to ${this.passwordResetEmail}. Click the link inside this email to reset your password.`;
            })
            .catch(reason => {
                this.messageInfo = "";
                try {
                    this.messageError = `Could not reset password. ${reason.data.modelState[""][0]}`;
                } catch {
                    // catch in case the reason provided isn't the structure we expected.
                    this.messageError = `Could not reset password.`;
                }
                this.passwordResetError = reason;
            })
    }

    $onDestroy() {
        this.gpRouteAuthService.deregister(this.authEventOptions);
    }
}

gpHome.directive("gpLogin", [function (): ng.IDirective {
    return ({
        restrict: 'E',
        scope: {
        },
        link: ($scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any) => {
            $scope.$on('$destroy', () => controller.$onDestroy());
        },
        controller: LoginController,
        controllerAs: 'vm',
        bindToController: true,
        template: loginTemplate,
    });
}]);
